import {accountIntegrationLogService} from '@/projects/admin/services/account-integration-log-service';
import {integrationManagementService} from '@/projects/admin/services/integration-management-service';
import React, { useRef, useState } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { Button } from 'devextreme-react/button';
import { toast } from 'react-toastify';
import DataGrid, { DataGridTypes } from 'devextreme-react/cjs/data-grid';

const MasterDetailGrid =(props: DataGridTypes.MasterDetailTemplateData & { masterDataGridRef: React.RefObject<DataGrid> }) => {
  const dataGridRef = useRef<DataGrid>(null);

      const [mainStore] = useState(new CustomStore({   
         byKey: async (key, loadOptions: any) => {
                    var returnObject = null;                   
                    if (key) {
                        const objectsByID = (await accountIntegrationLogService.getSupplierLogDetailList(loadOptions,props.data.data.retailerCode,props.data.data.retailerId))
                        returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                    }
                    return returnObject
                },
        load:async (loadOptions: any) => {
            if (props.data.data.retailerCode) {               
              const result = accountIntegrationLogService.getSupplierLogDetailList(loadOptions,props.data.data.retailerCode,props.data.data.retailerId)
              return result;
            }
        },
    }));      
const [retryButtonDisabled, setDisable] =useState(false);
const [buttonStatus, setButtonStatus] = useState<{ [key: string]: string }>({});
const updateButtonText = (rowIndex: string, text: string) => {
  setButtonStatus(prev => ({
      ...prev,
      [rowIndex]: text
  }));
};
const isVisibleForRetry = (data: any) => {
  return (
      data.data.isRetry && 
      data.data.log === 'END' && 
      (props.data.data.retailerId !== '6' || (props.data.data.retailerId === '6' && data.data.jobName === 'FlashSale'))
  );
};

const isVisibleForRetailService = (data: any) => {
  return props.data.data.retailerId === '6' && data.data.isRetry && data.data.jobName !== 'FlashSale';
};

const isVisibleForEcommerceService = (data: any) => {
  return props.data.data.retailerId === '6' && data.data.isRetryEticaret && data.data.jobName !== 'FlashSale';
};
const startjob = async (tenantid: string, jobname:string, jobtype:string|null,data:any )=> {
 
  updateButtonText(data.rowIndex, t('running'));
  setDisable(true);  
 
  const params: any = {};
   params.tenantId=tenantid;
   params.jobName=jobname;
   params.jobType=jobtype;
   var response= await integrationManagementService.startJob(params);
   
   setTimeout(async () => 
    {
        if( response.data.message!='OK')
        {   
            toast.error(response.data.message);  
            setDisable(false);
            updateButtonText(data.rowIndex, t('retry'));
        }
        else  
        {
            toast.success('Job başlatıldı.');
            setDisable(false);
            updateButtonText(data.rowIndex, t('retry'));
          
            props.masterDataGridRef.current?.instance.refresh();
        
        }   
    }, 3000);
}
  return (
    <React.Fragment>     
      <DataGridWrapper 
              props={{ id: 'log-list-details', ref: dataGridRef }}
               datasource={mainStore}               
                pagerVisible={true}
                remoteOperations={true}
                enableCustomToolbarContent={false}
                searchPanelVisible={false}                
                columnChooser={false}
                filterVisible={true}
                headerFilterVisible={true}  
                columnAutoWidth={true}  
                wordWrapEnabled={true}
                editingConfig=
                                     {{
                                          allowDeleting: false,
                                          allowUpdating: false,
                                          allowAdding:false
                                      }}
                 columns={[
                          {
                            dataField: 'layer',
                            caption: t('layer'),
                            filtering: true,
                            allowSorting: true,
                          },
                          {
                            dataField: 'jobName',
                            caption: t('job_name'),
                            filtering: true,
                            allowSorting: true,
                          },
                          {
                            dataField: 'platform',
                            caption: t('platform'),
                            filtering: true,
                            allowSorting: true,
                          },
                          {
                            dataField: 'processDate',
                            caption: t('process_date'),
                            allowSorting: true,
                          },
                          {
                            dataField: 'systemDatetime',
                            caption: t('system_date'), 
                            dataType: 'datetime',
                            format: "dd/MM/yyyy HH:mm:ss",
                            filtering: true,
                            allowSorting: true,
                          },
                          {
                            dataField: 'log',
                            caption: 'Log',
                            filtering: true,
                            allowSorting: true,
                          },
                          {
                            dataField: 'errorMessage',
                            caption: t('error'),
                            filtering: true,
                            allowSorting: true,
                          } ,
                          {
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: (data: any) => (
                              <>
                                <Button
                                 id={data.rowIndex}
                                 text={buttonStatus[data.rowIndex] || t('retry')}
                                 disabled={retryButtonDisabled}                                
                                 type="default"
                                 stylingMode="contained"
                                 icon='refresh'
                                 onClick={() => startjob(props.data.data.retailerId, data.data.jobName, null, data)}
                                 visible={isVisibleForRetry(data)} />
                                <Button
                                   id={data.rowIndex}
                                   text={buttonStatus[data.rowIndex] || t('retry_retail_service')}
                                  disabled={retryButtonDisabled}
                                  type="default"
                                  stylingMode="contained"
                                  icon='refresh'
                                  onClick={() => startjob(props.data.data.retailerId, data.data.jobName, 'Parekende', data)}
                                  visible={isVisibleForRetailService(data)}/>
                                <Button
                                  id={data.rowIndex}
                                  text={buttonStatus[data.rowIndex] || t('retry_e_commerce_service')}
                                  disabled={retryButtonDisabled}
                                  type="default"
                                  stylingMode="contained"
                                  icon='refresh'
                                  onClick={() => startjob(props.data.data.retailerId, data.data.jobName, 'ETicaret', data)}
                                  visible={isVisibleForEcommerceService(data)} />
                               
                              </>
                            ),                           
                        }                         
                        ]}
                        />
       
    </React.Fragment>
  );
};
   
export default MasterDetailGrid;